import { render, staticRenderFns } from "./FeedMixerSubmissionForm.vue?vue&type=template&id=439b2529"
import script from "./FeedMixerSubmissionForm.vue?vue&type=script&lang=js"
export * from "./FeedMixerSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports